import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { AuditlogService } from '../../services/auditlog';

interface Column {
  field: string;
  header: string;
}

@Component({
  imports: [TableModule, SelectModule, TagModule, CommonModule, FormsModule, BreadcrumbModule],
  templateUrl: './auditlog.html',
  styleUrl: './auditlog.scss'
})
export class Auditlog implements OnInit {
  public service = inject(AuditlogService);
  protected home: MenuItem = { label: 'Audit Log' };
  public cols!: Column[];

  ngOnInit() {
    this.cols = [
      { field: 'app', header: 'App' },
      { field: 'created', header: 'Created' },
      { field: 'msg', header: 'Msg' },
      { field: 'statusId', header: 'Durchführungs ID' },
      { field: 'aufgabeId', header: 'Aufgabe ID' },
      { field: 'fallaufgabeId', header: 'Fallaufgabe ID' },
      { field: 'routeInfo', header: 'Route Info' },
      { field: 'teilaufgabeId', header: 'Teilaufgabe ID' },
      { field: 'userId', header: 'User ID' },
      { field: 'userType', header: 'User Type' },
      { field: 'versionsUnique', header: 'Versions Unique' },
      { field: 'duration', header: 'Duration' },
      { field: 'level', header: 'Level' },
      { field: 'requestId', header: 'Request ID' },
    ]
  }
  public apps = [
    { label: 'Admin', value: 'index.admin.ts' },
    { label: 'Korrektor', value: 'index.korrektor.ts' },
    { label: 'Lernbegleiter', value: 'index.lernbegleiter.ts' }
  ];
}
